import { createReducer, createSetter } from "@/redux/helpers/reducer";

import * as actions from "./personalSettings.actions";

const initialState = {
  saved: {},
  isLoaded: false,
};

export default createReducer(initialState, {
  [actions.setSaved]: createSetter("saved"),
  [actions.setIsLoaded]: createSetter("isLoaded"),
});
